import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { profilesEndpoint } from '../constants';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');

  const fetchUser = async () => {
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const response = await axios.get(`${profilesEndpoint}me/`, {
        headers: {
          'Authorization': `Token ${token}`,
        },
      });
      setUser(response.data);
    } catch (err) {
      console.error("Failed to fetch user data for context:", err);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, [token]);

  const refreshUser = () => {
    fetchUser();
  };

  return (
    <UserContext.Provider value={{ user, loading, refreshUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
